import { Input } from "antd";
import PropTypes from "prop-types";

import classnames from "classnames";
import Label from "../Label";

const Simple = ({
  label,
  placeholder,
  errors,
  touched,
  icon,
  innerRef,
  required,
  direction,
  optional,
  trim = false,
  ...rest
}) => {
  return (
    <div
      className={classnames(
        "mobilityMutual__input",
        { "mobilityMutual__input--error": touched && errors },
        { "mobilityMutual__input--valid": touched && !errors },
        direction,
      )}
    >
      <Label
        label={label}
        icon={icon}
        required={required}
        optional={optional}
      />
      <div className={`mobilityMutual__input--field`}>
        <Input
          placeholder={placeholder}
          ref={innerRef}
          {...rest}
          onKeyUp={(e) => {
            e.target.value = trim
              ? e.target.value.replace(/\s+/g, "")
              : e.target.value;
          }}
        />
        {touched && errors && <p className={"input--errors"}>{errors}</p>}
      </div>
    </div>
  );
};

Simple.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
};

Simple.defaultProps = {
  label: "",
  placeholder: "",
};
export default Simple;
